import {HighlightCategory} from '__generated__/__types__';
import {isEmpty} from 'lodash';
import {productPlaceholder} from '@/lib/placeholders';

export const getSolidIconHighlightCategory = (data: HighlightCategory) => {
    const iconUrl = data?.featured_icon_solid ? data?.featured_icon_solid : data?.featured_icon;
    if (isEmpty(iconUrl)) {
        return productPlaceholder;
    }
    return iconUrl;
};
